module.exports = __webpack_public_path__ + "static/media/container-storage.a53540e2.svg";